import { SOCKET_EVENT_NAMES } from '@/constants/socket.events';
import { notify } from '@/helpers/index';
import { WidgetConfigStore } from '@/state/WidgetConfigStore';
import { convertTo12Hour } from '@/utils/index';
import { useChatConversation } from '../useChatConversation';
import { SocketRequest } from '@/config/socket';

export const useWidgetConfig = () => {
  const { delete_file } = useChatConversation();
  const publish = async () => {
    WidgetConfigStore.publishLoading();

    if (WidgetConfigStore.old_brand_logo_url) {
      delete_file(WidgetConfigStore.old_brand_logo_url);
    }

    const payload = WidgetConfigStore.config?.value;
    payload.availability.officeHours = payload.availability?.officeHours?.map(
      (day: any) => ({
        openDay: day?.openDay,
        openTime: day?.openTime,
        closeTime: day?.closeTime,
      }),
    );
    try {
      await SocketRequest(SOCKET_EVENT_NAMES.UPDATE_CONFIG, { data: payload });
    } catch (error) {
      notify('error', 'Failed to update config');
    } finally {
      WidgetConfigStore.finishPublishLoading();
    }
    WidgetConfigStore.config.value.availability.officeHours[0].openTime =
      convertTo12Hour(payload?.availability?.officeHours[0]?.openTime);
    WidgetConfigStore.config.value.availability.officeHours[0].closeTime =
      convertTo12Hour(payload?.availability?.officeHours[0]?.closeTime);
  };

  const get_spark_gpt_question_list = async () => {
    WidgetConfigStore.set_fetching_spark_gpt_question(true);
    try {
      const response = await SocketRequest('get_spark_gpt_question_list', {
        data: null,
      });
      if (!response?.error && response?.data) {
        WidgetConfigStore.add_spark_gpt_question_list(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to fetch questions');
    } finally {
      WidgetConfigStore.set_fetching_spark_gpt_question(false);
    }
  };

  const get_widget_config = async () => {
    WidgetConfigStore.set_fetching(true);
    try {
      const response = await SocketRequest(SOCKET_EVENT_NAMES.GET_CONFIG, {
        data: { widget_id: null },
      });
      if (response?.data) {
        WidgetConfigStore.addConfig(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to fetch widget config');
    } finally {
      WidgetConfigStore.set_fetching(false);
    }
  };

  const get_faqs = async () => {
    WidgetConfigStore.set_fetching_faq(true);
    try {
      const response = await SocketRequest('get_faqs', { data: null });
      if (response?.data) {
        WidgetConfigStore.add_faqs(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to fetch FAQs');
    } finally {
      WidgetConfigStore.set_fetching_faq(false);
    }
  };

  const create_spark_gpt_question = async (payload: any) => {
    WidgetConfigStore.set_is_adding_spark_gpt_question(true);
    try {
      const response = await SocketRequest('add_spark_gpt_question', {
        data: payload,
      });
      if (!response?.error && response?.data) {
        WidgetConfigStore.add_spark_gpt_question(response?.data);
        WidgetConfigStore.set_add_editing(false);
      }
    } catch (error) {
      notify('error', 'Failed to add question');
    } finally {
      WidgetConfigStore.set_is_adding_spark_gpt_question(false);
    }
  };

  const create_faq = async (payload: any) => {
    WidgetConfigStore.set_is_adding_faq(true);
    try {
      const response = await SocketRequest('add_faq', { data: payload });
      if (response?.data) {
        WidgetConfigStore.add_faq(response?.data);
        WidgetConfigStore.set_add_editing(false);
      } else {
        notify('error', 'Failed to add FAQ');
      }
    } catch (error) {
      notify('error', 'Failed to add FAQ');
    } finally {
      WidgetConfigStore.set_is_adding_faq(false);
    }
  };

  return {
    publish,
    get_widget_config,
    get_faqs,
    create_faq,
    get_spark_gpt_question_list,
    create_spark_gpt_question,
  };
};
